import styled, { css } from 'styled-components';

interface IKakarikoGridRowStyleProps {
  $textAlignment?: textAlignmentOptions;
}

export const StyledKakarikoGridRow = styled.div<IKakarikoGridRowStyleProps>`
  ${(props: IKakarikoGridRowStyleProps & { theme: any }) => {
    let { theme, $textAlignment } = props;
    $textAlignment = $textAlignment || 'center';

    return css`
      display: contents;
      font-size: 13px;
      height: 52px;
      line-height: 16px;

      .cell {
        align-items: ${$textAlignment};
        background: ${theme.white};
        background: var(--white-full);
        border-color: ${theme.defaultLight};
        border: 1px solid var(--default-light);
        display: flex;
        justify-content: center;
        padding: 10px 9px 12px;
        vertical-align: middle;
        text-align: center;
        word-break: break-all;
        word-break: break-word;
        width: auto;

        button {
          box-shadow: none;
        }
      }
    `;
  }};
`;
